import type { ReactNode } from "react"
import { cn } from "./lib"

/** Markers and text are supplied by the caller, keeping formatting and localization outside the UI primitive. */
export type SectionHeadingProps = {
	marker: ReactNode
	title: ReactNode
	description?: ReactNode
	id?: string
	level?: 2 | 3
	aside?: ReactNode
	className?: string
}

/** A compact semantic section heading with a decorative marker and optional supporting content. */
export function SectionHeading({
	marker,
	title,
	description,
	id,
	level = 2,
	aside,
	className,
}: SectionHeadingProps) {
	const Heading = level === 2 ? "h2" : "h3"
	return (
		<header className={cn("flex min-w-0 items-start gap-2.5", className)}>
			<span
				aria-hidden
				className="grid size-[25px] flex-[0_0_25px] place-items-center rounded-[7px] bg-mm-muted text-[11px] font-extrabold text-[var(--ui-marker-foreground,var(--mm-muted-fg))]"
			>
				{marker}
			</span>
			<div className="min-w-0">
				<Heading
					id={id}
					className="mb-[3px] text-[15px] font-bold leading-[1.45]"
				>
					{title}
				</Heading>
				{description != null && (
					<p className="text-[11px] leading-[1.45] text-mm-muted-fg">
						{description}
					</p>
				)}
			</div>
			{aside != null && (
				<span className="ms-auto text-[11px] text-mm-muted-fg [@media(max-width:479px)]:hidden">
					{aside}
				</span>
			)}
		</header>
	)
}
